import React, { useState } from 'react';
import {
    Alert,
    Image,
    View,
    Text,
    TouchableOpacity,
    TextInput,
    ScrollView,
    Modal,
    StatusBar,
    Dimensions,
    SafeAreaView,
    Platform,
    KeyboardAvoidingView,
    TouchableWithoutFeedback,
    Keyboard,
    ActivityIndicator,
    Linking
} from 'react-native';
import axios from 'axios';
import { useLogScreen } from '../../useLogScreen';
import Svg, { Path } from 'react-native-svg';
const { width, height } = Dimensions.get('window');
import { Ionicons, FontAwesome5 } from '@expo/vector-icons';
// Ícone de seta para voltar
const BackArrowIcon = () => (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <Path
            d="M18.5489 0.939645C19.151 1.52543 19.151 2.47518 18.5489 3.06097L9.36108 12.0003L18.5489 20.9396C19.151 21.5254 19.151 22.4752 18.5489 23.061C17.9469 23.6468 16.9707 23.6468 16.3686 23.061L5.00049 12.0003L16.3686 0.939645C16.9707 0.353859 17.9469 0.353859 18.5489 0.939645Z"
            fill="#730d83"
        />
    </Svg>
);

const AnaliseDocumental = ({ route, navigation }) => {
    useLogScreen('AnaliseDocumental');
    const { usuario_id } = route.params || {};
    const [modalVisible, setModalVisible] = useState(false); // Controla o primeiro modal (categoria)
    const closeMenu = () => setModalVisible(false);
    return (
        <SafeAreaView style={styles.safeArea}>
            <View style={styles.headerContainer}>
                <TouchableOpacity onPress={() => navigation.goBack()} style={styles.backButton}>
                    <BackArrowIcon />
                </TouchableOpacity>
                <Text style={styles.headerTitle} allowFontScaling={false}>
                    Emissão de Certidões
                </Text>
            </View>
            <Text style={styles.classificacaoText} allowFontScaling={false}>
                {/*  */}
            </Text>
            <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
                <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
                    <ScrollView contentContainerStyle={styles.scrollContainer}>
                        <View style={styles.container}>

                            <View style={styles.row}>
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>Ao solicitar uma emissão de certidões da imoGo, você recebe, em até um dia útil, todas as certidões relativas a situação jurídica do proprietário e do imóvel, necessárias para a segurança da transação e o fechamento da venda.</Text>
                            </View>

                            <View style={styles.row}>
                                {/* Os inputs de tirar foto */}
                                <View style={styles.optionButtonsContainer}>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => setModalVisible(true)}>
                                        <Image
                                            source={require('../../assets/icons/plus.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Solicitar nova emissão</Text>
                                        </View>
                                    </TouchableOpacity>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => navigation.navigate('PreAnaliseDocumental', { usuario_id })}>
                                        <Image
                                            source={require('../../assets/icons/download.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Minhas emissões</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </View>
                            {/* Botão Salvar */}
                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={styles.laterButton}>
                                    <Image
                                        source={require('../../assets/icons/home.png')} // Ícone de terminar mais tarde
                                        style={styles.laterIcon}
                                    />
                                    <Text
                                        style={styles.laterButtonText}
                                        allowFontScaling={false}
                                        onPress={() => navigation.navigate('Home', { usuario_id })}
                                    >
                                        Voltar para home
                                    </Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                        <Modal
                            visible={modalVisible}
                            animationType="slide"
                            transparent={true}
                            onRequestClose={() => setModalVisible(false)}
                        >

                            <View style={styles.modalOverlay}>
                                <View style={styles.modalContainer}>
                                    <TouchableOpacity style={styles.closeButton} onPress={() => setModalVisible(false)}>
                                        <Ionicons name="close" size={24} color="#FFF" />
                                    </TouchableOpacity>
                                    <Text style={styles.modalTitle} allowFontScaling={false}>Tipo de emissão: </Text>
                                    <View style={styles.categoryContainer}>
                                        <TouchableOpacity style={styles.categoryButton} onPress={() => { closeMenu(); navigation.navigate('CadastroAnalise', { usuario_id, status: 1 }) }}>
                                            <Image
                                                source={require('../../assets/icons/2perfil.png')}
                                                style={styles.categoryIcon}
                                            />
                                            <Text style={styles.categoryText} allowFontScaling={false}>CPF</Text>
                                        </TouchableOpacity>
                                        <TouchableOpacity style={styles.categoryButton} onPress={() => { closeMenu(); navigation.navigate('CadastroAnaliseCNPJ', { usuario_id, status: 1 }) }}>
                                            <Image
                                                source={require('../../assets/icons/cnpj.png')}
                                                style={styles.categoryIcon}
                                            />
                                            <Text style={styles.categoryText} allowFontScaling={false}>CNPJ</Text>
                                        </TouchableOpacity>
                                    </View>
                                </View>
                            </View>
                        </Modal>
                    </ScrollView>
                </TouchableWithoutFeedback>
            </KeyboardAvoidingView>
        </SafeAreaView>
    );
};

const styles = {

    loadingContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fundo translúcido
    },
    loadingText: {
        color: '#FFF',
        marginTop: 10,
        fontSize: 16,
    },

    // voltar 
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: width * 0.05,
        paddingVertical: height * 0.02,
        backgroundColor: '#F5F5F5',
    },
    headerTitle: {
        fontSize: width * 0.04,
        fontWeight: 'bold',
        color: '#1F2024',
        textAlign: 'center'
    },
    classificacaoText: {
        fontSize: width * 0.035,
        fontWeight: 'bold',
        color: '#1F2024',
        marginBottom: 10,
        marginTop: 10,
        textAlign: 'center',
        paddingLeft: 20,
    },

    backButton: {
        position: 'absolute',
        left: 20,
    },
    //
    safeArea: {
        flex: 1,
        backgroundColor: '#F5F5F5',

    },
    scrollContainer: {
        paddingVertical: 20,
        paddingHorizontal: 15,
        alignItems: 'center',
    },
    container: {
        width: '90%',
    },
    row: {
        marginBottom: 20,
        width: '100%',
    },

    optionButton: {
        borderWidth: 1,
        borderColor: '#E9E9E9',
        borderRadius: 25,
        marginHorizontal: 6,
        backgroundColor: '#E9E9E9',
        width: Platform.select({ ios: width * 0.11, android: width * 0.11 }),
        height: Platform.select({ ios: width * 0.11, android: width * 0.11 }),
        justifyContent: 'center',
        alignItems: 'center',
    },

    optionText: {
        fontSize: width * 0.029,
        color: '#494A50',
    },


    checkboxLabel: {
        textAlign: "justify",
        fontSize: 14,
        color: 'black',
        marginLeft: 10,
    },
    buttonContainer: {
        marginTop: 40, // Ajuste do espaçamento superior
        alignItems: 'center',
    },

    laterButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    laterIcon: {
        width: 20,
        height: 20,
        marginRight: 8,
    },
    laterButtonText: {
        color: '#730d83',
        fontSize: Platform.select({ ios: width * 0.04, android: width * 0.04 }), // Ajuste no tamanho da fonte
        fontWeight: '600',
    },
    // input que abre     

    optionButtonsContainer: {
        width: '100%',
        marginTop: 20,
        alignItems: 'center',
    },
    optionButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: '#F5F5F5',
        borderColor: '#D3D3D3',
        borderWidth: 1,
        borderRadius: 10,
        width: '100%',
        padding: 15,
        marginBottom: 10,
    },
    optionIcon: {
        width: 24,
        height: 24,
        marginRight: 15,
        // tintColor: '#730d83', // Deixa a cor dos ícones laranja
    },
    optionTextContainer: {
        flexDirection: 'column',
    },
    optionTextTitle: {
        fontSize: width * 0.03,
        fontWeight: 'bold',
        color: '#1F2024',
    },
    optionTextSubtitle: {
        fontSize: width * 0.03,
        color: '#7A7A7A',
    },

    // modal 

    modalOverlay: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    modalContainer: {
        width: width,
        paddingVertical: height * 0.03,
        paddingHorizontal: width * 0.05,
        backgroundColor: '#730d83',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
    },
    closeButton: {
        position: 'absolute',
        top: height * 0.02,
        left: width * 0.05,
    },
    modalTitle: {
        fontSize: width * 0.05,
        color: '#FFF',
        fontWeight: 'bold',
        marginBottom: height * 0.03,
        textAlign: 'center',
    },
    categoryContainer: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        width: '100%',
    },
    categoryButton: {
        width: width * 0.22,
        height: width * 0.22,
        backgroundColor: '#FFF',
        borderRadius: 15,
        justifyContent: 'center',
        alignItems: 'center',
        padding: width * 0.02,
        marginBottom: width * 0.05
    },
    categoryIcon: {
        width: '60%',
        height: '60%',
        resizeMode: 'contain',
    },
    categoryText: {
        marginTop: height * 0.01,
        fontSize: width * 0.03,
        color: '#730d83',
        fontWeight: 'bold',
        textAlign: 'center',
    },

};

export default AnaliseDocumental;